import React from 'react';
import {
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
  MotifButton,
  MotifIcon,
} from '@ey-xd/motif-react';
import { BodyContent, HeaderWrapper, ParagraphStyle } from '@organisms/modals/styles/modalStyles';

const CustomErrorModal = ({
  show,
  headerText,
  message,
  onClose,
  closeButtonText,
  onButtonClicked,
}) => {
  const Header = ({ children }) => <HeaderWrapper>{children}</HeaderWrapper>;
  const bodyContent = <BodyContent>{message}</BodyContent>;
  const headerTitle = <span style={{ marginLeft: 11, fontSize: 16 }}>{headerText}</span>;

  return (
    <MotifModal
      variant="alt"
      show={show}
      onClose={onClose}
      style={{ width: '485px' }}
      focusTrapOptions={{
        initialFocus: false,
      }}
    >
      <MotifModalHeader closeModalButton={true}>
        <Header>
          <MotifIcon
            src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTIgMkM2LjQ4IDIgMiA2LjQ4IDIgMTJzNC40OCAxMCAxMCAxMCAxMC00LjQ4IDEwLTEwUzE3LjUyIDIgMTIgMnptMSAxNWgtMnYtMmgydjJ6bTAtNGgtMlY3aDJ2NnoiLz48L3N2Zz4="
            style={{
              color: '#F95D54',
              lineHeight: 1,
            }}
          />
          {headerTitle}
        </Header>
      </MotifModalHeader>
      <MotifModalBody>
        <ParagraphStyle> {bodyContent}</ParagraphStyle>
      </MotifModalBody>
      <MotifModalFooter>
        <MotifButton variant="secondary" type="button" onClick={onButtonClicked}>
          {closeButtonText}
        </MotifButton>
      </MotifModalFooter>
    </MotifModal>
  );
};
export default CustomErrorModal;
